(() => {
  function mountDeferredMedia(deferredMedia) {
    if (!deferredMedia || deferredMedia.dataset.loaded === 'true') return;

    const template = deferredMedia.querySelector('template');
    if (!template) return;

    deferredMedia.dataset.loaded = 'true';

    const poster = deferredMedia.querySelector('.deferred-media__poster');
    if (poster) poster.remove();

    const content = template.content.cloneNode(true);
    deferredMedia.appendChild(content);

    const video = deferredMedia.querySelector('video');
    const iframe = deferredMedia.querySelector('iframe');


    if (video) {
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('autoplay', '');
      video.setAttribute('controls', '');

      video.muted = true;
      video.playsInline = true;

      video.setAttribute('webkit-playsinline', '');

      requestAnimationFrame(() => {
        const playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.catch(() => {});
        }
      });
    }


    if (iframe) {
      let src = iframe.getAttribute('src');

      if (!src.includes('autoplay=1')) {
        src += (src.includes('?') ? '&' : '?') + 'autoplay=1&playsinline=1';
      }

      iframe.setAttribute('src', src);
    }
  }

  document.addEventListener(
    'click',
    event => {
      const poster = event.target.closest('.deferred-media__poster');
      if (!poster) return;

      event.preventDefault();
      event.stopPropagation();

      const deferredMedia = poster.closest('deferred-media, product-model');
      if (!deferredMedia) return;

      mountDeferredMedia(deferredMedia);
    },
    true
  );

})();
